module.exports = __webpack_public_path__ + "static/img/bg_vip_desc_dialog_bg_2.2d9853b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_vip_desc_dialog_bg_2.png
// module id = Xn7/
// module chunks = 0